
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utmb-index/[level2]",
      function () {
        return require("private-next-pages/utmb-index/[level2]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utmb-index/[level2]"])
      });
    }
  